import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#0A0A0A] border-t border-[#16161F] py-12 px-4" data-id="element-80">
      <div className="max-w-4xl mx-auto text-center" data-id="element-81">
        <div className="text-[#00A650] text-2xl font-black tracking-widest mb-4 uppercase" data-id="element-82">
          ⚽ FÚTBOL LISTO 360™
        </div>
        <p className="text-white text-base font-bold mb-2" data-id="element-83">
          El sistema #1 para entrenadores de fútbol juvenil en español.
        </p>
        <p className="text-[#B0B0C0] text-sm italic mb-8 font-medium" data-id="element-84">
          Porque entrenar no debería costarte todas las noches de la semana.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-sm text-[#B0B0C0] mb-8 font-bold" data-id="element-85">
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-86">
            📧 soporte.futbollisto360@gmail.com
          </span>
          <span className="hidden sm:inline text-[#333]" data-id="element-87">•</span>
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-88">
            📲 @futbollisto360
          </span>
          <span className="hidden sm:inline text-[#333]" data-id="element-89">•</span>
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-90">
            🌐 www.futbollisto360.com
          </span>
        </div>

        <div className="h-px bg-[#16161F] mb-8 w-full max-w-md mx-auto" data-id="element-91" />

        <p className="text-[#5A5A66] text-xs font-bold uppercase tracking-wider" data-id="element-92">
          © FÚTBOL LISTO 360™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}